'use strict';

//
// Variables
//
const body = document.querySelector( 'body' ),
    headerScrolled = 'site-header--scrolled';

//
// Hambuger elements
//
const hamburgerMenuVisible = 'site-header__hamburger-menu--visible',
    hamburgerMenuIcon = document.querySelector( '.js-show-hamburger' ),
    hamburgerMenu = document.querySelector( '.site-header .navbar' ),
    hamburgerActive = 'site-header__icon--hamburger--active',
    siteHeaderOpen = 'site-header--open';

const siteHeader = document.querySelector( '.site-header' );

let mobileViewHandler;

//
// Methods
//
const siteHeaderScroll = () => {
    const y = window.scrollY;
    if (y >= 100) {
        siteHeader.classList.add( headerScrolled );
    }else {
        siteHeader.classList.remove( headerScrolled );
    }
};

const showHamburgerMenu = () => {
    hamburgerMenuIcon.classList.toggle( hamburgerActive );
    if ( hamburgerMenuIcon.classList.contains( hamburgerActive ) ) {
        hamburgerMenu.classList.add( hamburgerMenuVisible );
        body.classList.add( 'scrolled-locked-mobile' );
        siteHeader.classList.add( siteHeaderOpen );
    } else {
        hamburgerMenu.classList.remove( hamburgerMenuVisible );
        body.classList.remove( 'scrolled-locked-mobile' );
        siteHeader.classList.remove( siteHeaderOpen );
    }

};

const prepareForMobileView = () => {
    
    const windowWidth = window.innerWidth;
    if (windowWidth <= 992) {
        if (!mobileViewHandler) {
            mobileViewHandler = 1;
            
        }
    }else{
        if (mobileViewHandler) {
            mobileViewHandler = 0;
        }
    }
};

//
// Inits & Event Listeners
//
window.addEventListener( 'DOMContentLoaded', siteHeaderScroll );
window.addEventListener( 'scroll', siteHeaderScroll, { passive: true } );
if( hamburgerMenuIcon ) hamburgerMenuIcon.addEventListener( 'click', showHamburgerMenu );